import $http from './http'
import config from './config'

export default {
    name:'logs',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    getLogInfo(data) {
        return $http.post(this.getUrl(`/LogInfo/List`), data);
    },
    getLogs(data) {
        return $http.post(this.getUrl(`/LogInfo/Logs`), data);
    },
}


// WEBPACK FOOTER //
// ./src/apis/logsApis.js